import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Collapse,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveConsultationType } from './hooks/useSaveConsultationType';

export default function ConsultationTypeFormModal({
  open,
  onClose,
  onSave,
  consultationType,
  initialDescription,
}) {
  const navigate = useNavigate();
  const { save: saveConsultationType } = useSaveConsultationType();
  const [formDescription, setFormDescription] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setFormDescription(consultationType?.description ?? initialDescription ?? '');
      setError('');
    }
  }, [open, consultationType, initialDescription]);

  const save = () => {
    if (!formDescription.trim()) return;

    const payload = {
      description: formDescription,
    };

    saveConsultationType(consultationType ? consultationType.id : null, payload)
      .then(() => {
        onSave();
        onClose();
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/expired-session');
        } else {
          setError(err.response?.data ?? 'Erro ao salvar tipo de consulta.');
        }
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {consultationType ? 'Editar Tipo de Consulta' : 'Novo Tipo de Consulta'}
      </DialogTitle>
      <DialogContent>
        <Collapse in={!!error} sx={{ mb: 1 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {error}
          </Alert>
        </Collapse>
        <TextField
          autoFocus
          label="Descrição"
          fullWidth
          value={formDescription}
          onChange={(e) => setFormDescription(e.target.value)}
          inputProps={{ 'data-cy': 'consultation-type-description' }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={save}
          disabled={!formDescription.trim()}
          data-cy="save-consultation-type-btn"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConsultationTypeFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  consultationType: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
  }),
  initialDescription: PropTypes.string,
};

ConsultationTypeFormModal.defaultProps = {
  consultationType: null,
  initialDescription: '',
};
